document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`#cmdk-input`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});

const cartDrawer = document.querySelector(".cart-drawer__dialog");
if (cartDrawer) {
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "attributes" && mutation.attributeName === "open") {
              console.log(123)
                BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
            }
        }
    });
    
    observer.observe(cartDrawer, {
        attributes: true, 
    });
}

const quickview = document.querySelector(".quick-add-modal");
if (quickview) {
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "attributes" && mutation.attributeName === "open") {
              document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
            }
        }
    });
    
    observer.observe(quickview, {
        attributes: true, 
    });
}

